import { fromPairs, keyBy, mapValues, orderBy } from "lodash";
import { createSelector } from "reselect";

import { Plan, selectCurrentSubscriptionPlan } from "../subscriptions";

import { IApplicationSettings, IPlanLimits } from "./interfaces";

export interface IWithApplicationSettingsState {
  entities: {
    applicationSettings: IApplicationSettings;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectApplicationSettings(state: IWithApplicationSettingsState) {
  return state.entities.applicationSettings;
}

export function selectApplicationServerKey(state: IWithApplicationSettingsState): string | null {
  return selectApplicationSettings(state).webpushSubscriptions.applicationServerKey;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectDefaultTemplate(state: IWithApplicationSettingsState) {
  return selectApplicationSettings(state).defaultTemplate;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectDefaultVisualTemplate(state: IWithApplicationSettingsState) {
  return selectApplicationSettings(state).defaultVisualTemplate;
}
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectDefaultVisualTemplateContent(state: IWithApplicationSettingsState) {
  return selectApplicationSettings(state).defaultVisualTemplate.content;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectDefaultVisualTemplateAppearance(state: IWithApplicationSettingsState) {
  return selectDefaultVisualTemplateContent(state).appearance;
}

export function selectDefaultLogoUrl(state: IWithApplicationSettingsState): string {
  return selectDefaultVisualTemplateAppearance(state)?.appearanceLogoUrl?.value as string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectExampleTicket(state: IWithApplicationSettingsState) {
  return selectApplicationSettings(state).exampleTicket;
}
export function selectPoweredByFooterCode(state: IWithApplicationSettingsState): string | undefined {
  return selectApplicationSettings(state)?.poweredBy?.html;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectAuditLog = createSelector(selectApplicationSettings, (auditLogState: any) => auditLogState.auditLog);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectAuditLogTargets = createSelector(selectAuditLog, (auditLogState: any) =>
  keyBy(auditLogState?.targets, item => item.name)
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectAuditLogActions = createSelector(selectAuditLog, (auditLogState: any) =>
  keyBy(auditLogState?.actions, item => item.name)
);

export function selectStandardPlansLimits(
  state: IWithApplicationSettingsState
): Record<Plan, Record<keyof IPlanLimits, number>> {
  return mapValues(selectApplicationSettings(state).plans, plan =>
    mapValues(plan, limit => (limit === null ? Infinity : limit))
  );
}

export const selectStandardPlanLimitsForCurrentPlan = createSelector(
  selectStandardPlansLimits,
  selectCurrentSubscriptionPlan,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (plans: any, currentPlan: any) => {
    const planLimits = plans[currentPlan];
    return mapValues(planLimits, limit => (limit === null ? Infinity : limit));
  }
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectAgentsInFiltersLimit(state: IWithApplicationSettingsState) {
  return selectApplicationSettings(state).limits.maxAgentsInFilters;
}
export function selectMaxLanguagesInFilters(state: IWithApplicationSettingsState): number {
  return selectApplicationSettings(state).limits.maxLanguagesInFilters;
}

export function selectLanguageLabels(state: IWithApplicationSettingsState): Record<string, string> {
  const languageLabels = selectApplicationSettings(state).detectedLanguages;

  // sort by language full name
  const sortedLanguageLabels = fromPairs(orderBy(Object.entries(languageLabels), item => item[1]));

  return sortedLanguageLabels;
}
